/**
 * DEPRECATED: Sentiment Analysis Service
 *
 * This service is no longer used. Sentiment analysis has been moved to the backend
 * and is now performed via AWS Comprehend on the server side.
 *
 * The dynamoDBService.ts now uses the backend API (POST /reviews) which automatically
 * analyses sentiment and includes the results in the response.
 *
 * This file is kept for backward compatibility only.
 * All sentiment types are now exported from dynamoDBService.ts instead.
 */

console.warn('[DEPRECATED] sentimentService.ts is deprecated. Sentiment analysis is now handled by the backend.');

// Define sentiment types (for backward compatibility)
export enum SentimentType {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  MIXED = 'MIXED'
}

// Interface for sentiment analysis result
export interface SentimentResult {
  sentiment: SentimentType;
  score: number;
  isPositive: boolean;
}

/**
 * DEPRECATED: Analyse sentiment of text
 * Sentiment analysis is now performed server-side by the backend
 *
 * This function is kept for backward compatibility but always returns positive
 */
export const analyzeSentiment = async (text: string): Promise<SentimentResult> => {
  console.warn('[DEPRECATED] analyzeSentiment() is deprecated. Sentiment analysis is handled by the backend.');

  // Return default positive sentiment
  return {
    sentiment: SentimentType.POSITIVE,
    score: 0.95,
    isPositive: true
  };
};

/**
 * DEPRECATED: Check if a text has positive sentiment
 * Sentiment analysis is now performed server-side by the backend
 */
export const hasPositiveSentiment = async (text: string): Promise<boolean> => {
  console.warn('[DEPRECATED] hasPositiveSentiment() is deprecated. Sentiment analysis is handled by the backend.');
  return true;
};
